import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import GitHubIcon from "@mui/icons-material/GitHub";

function Copyright() {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
      }}
    >
      {"Copyright © "}
      {new Date().getFullYear()}
      {"."}
      <a target="blank" href="https://github.com/0xgun/github-app">
        <GitHubIcon sx={{ fontSize: "inherit" }} />
      </a>
    </Typography>
  );
}

const defaultTheme = createTheme();

export default function StickyFooter() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <Box
        component="footer"
        sx={{
          p: 2,
          mt: "auto",
          position: "fixed",
          bottom: 0,
          width: "100%",
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[200]
              : theme.palette.grey[800],
          marginTop: "10px",
        }}
      >
        <Container maxWidth="sm">
          <Copyright />
        </Container>
      </Box>
    </ThemeProvider>
  );
}
